import type { FaireProductEntity } from "../../entity_types/product";

export const p_esv48znwf2: FaireProductEntity = {
  token: "p_esv48znwf2",
  type: "product",
  name: "Sunday Pasta Washi Tape",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/38f92cf0633ad3bdd915e117212c3d8bb431a58a4f242d21a0f5411963234de5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7232336b752407727a5a4686c6876dd1645aca7ed1078b252b5a36e1ae18f05.jpeg",
    "https://cdn.faire.com/fastly/385c0c95c4a3c45e8be6ba7ed8781e06e0825b3972ad3537963671e43b2d66b5.jpeg"
  ],
  priceDollars: 3.5,
  description: "Wrap up your thank-yous or craft your gratitude journals in style with this delightful washi tape - a paper based tape that leaves no residue. \n\n * Roll of 10m x 15mm tape \n * Features 'Sunday Pasta' pattern design with illustrated fishes, farfalle, tomatoes, and cheeses - all the ingredients for the perfect Sunday Sauce, Caesar Salad, or Coastal Mediterranean Feast. \n * Sustainably packaged in a recyclable paper box - no plastic here! ",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:10.230Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
